// src/components/Form/Input/ToggleBillingPeriodNew.js // <-- НОВОЕ ИМЯ ФАЙЛА

import React, { useCallback } from 'react';

// Вспомогательная функция для форматирования цены
const formatPrice = (price) => {
    if (price === null || price === undefined || isNaN(Number(price))) {
        return null;
    }
    return parseFloat(price).toFixed(2);
};

/**
 * Компонент-«переключатель» тарифа (Monthly / Annually). NEW VERSION.
 * Принимает цены как props и отображает их внутри себя. Не делает API запросов.
 *
 * @param {string}   billingPeriod        - Текущее значение тарифа: 'monthly' или 'annually'.
 * @param {Function} onBillingPeriodChange - Колбэк, вызываемый при смене тарифа.
 * @param {boolean}  disabled            - Флаг, запрещающий менять тариф (по умолчанию false).
 * @param {number|string|null} monthlyPrice - Месячная цена.
 * @param {number|string|null} annualPrice  - Годовая цена.
 * @param {number|string|null} effectiveMonthlyPrice - Эффективная месячная цена для годового плана (уже рассчитанная).
 */
export default function ToggleBillingPeriodNew({ // <-- Новое имя
  billingPeriod = 'monthly',
  onBillingPeriodChange,
  disabled = false,
  monthlyPrice,
  annualPrice,
  effectiveMonthlyPrice,
}) {

  const handleBillingToggle = useCallback(() => {
    if (!disabled) {
      const newBilling = billingPeriod === 'monthly' ? 'annually' : 'monthly';
      if (onBillingPeriodChange) {
        onBillingPeriodChange(newBilling);
      }
    }
  }, [disabled, billingPeriod, onBillingPeriodChange]);

  const handleKeyPress = useCallback(
    (e) => {
      if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
        handleBillingToggle();
      }
    },
    [disabled, handleBillingToggle]
  );

  // Форматируем цены для отображения
  const displayMonthly = formatPrice(monthlyPrice);
  const displayAnnual = formatPrice(annualPrice);
  const displayEffectiveMonthly = effectiveMonthlyPrice !== null && effectiveMonthlyPrice !== undefined
                                    ? String(effectiveMonthlyPrice) // Предполагаем, что округлено родителем
                                    : null;

  const showPrices = displayMonthly !== null || displayAnnual !== null;

  return (
    <div className="billing-toggle-container" style={{ width: '100%' }}>
      <div className="billing-toggle" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: showPrices ? '8px' : '0' }}>
        <span className={`billing-text ${ billingPeriod === 'monthly' ? 'active' : 'inactive' }`}>
          Monthly
        </span>
        <div
          className={`toggle ${billingPeriod === 'annually' ? 'checked' : ''}`}
          onClick={!disabled ? handleBillingToggle : undefined}
          role="switch"
          aria-checked={billingPeriod === 'annually'}
          tabIndex={disabled ? -1 : 0}
          onKeyPress={handleKeyPress}
          style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1 }}
        >
          <div className="toggle__container"><div className="toggle__circle" /></div>
        </div>
        <span className={`billing-text ${ billingPeriod === 'annually' ? 'active' : 'inactive' }`}>
          Annually
        </span>
      </div>

      {/* Блок с ценами */}
      {showPrices && (
        <div className="billing-prices" style={{ textAlign: 'center', minHeight: '20px', fontSize: '0.9em' }}>
          {billingPeriod === 'monthly' ? (
            displayMonthly !== null ? (
              <span className="billing-price active">${displayMonthly}/month</span>
            ) : ( <span className="billing-price inactive" style={{ color: '#888' }}>Price unavailable</span> )
          ) : (
            displayAnnual !== null && displayEffectiveMonthly !== null && displayMonthly !== null ? (
              <>
                <span className="billing-price inactive" style={{ textDecoration: 'line-through', marginRight: '8px', color: '#888' }}>${displayMonthly}</span>
                <span className="billing-price active">${displayEffectiveMonthly}/month</span>
                <span style={{ marginLeft: '8px', color: '#666' }}>(paid annually)</span>
              </>
            ) : displayMonthly !== null ? (
               <span className="billing-price active">${displayMonthly}/month</span>
            ) : ( <span className="billing-price inactive" style={{ color: '#888' }}>Price unavailable</span> )
          )}
        </div>
      )}
    </div>
  );
}